const doc = [({"da":({"js":({"merfoto":({"layout":({"index":({"webshop":"Webshop", "downloads":"Downloads", "orders":"Ordrer", "albums":"Albums", "merfoto":"MERfoto"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;